export const parseCC = (cc) => {
  if (cc.length === 16) {
    // SIDEC
    return {
      agency: cc.slice(0, 4),
      operation: cc.slice(4, 7),
      account: cc.slice(7, 15),
      dv: cc.slice(15, 16),
    };
  } else if (cc.length === 21) {
    // NSGD
    return {
      agency: cc.slice(0, 4),
      operation: cc.slice(4, 8),
      account: cc.slice(8, 20),
      dv: cc.slice(20, 21),
    };
  } else {
    return {
      agency: "",
      operation: "",
      account: "",
      dv: "",
    };
  }
};
